import { PromotionalContentSummary } from '../shared/types'
import { baseUrls } from './baseUrls.utils';

const startsWithString = '{{promotionalContent:';

export const htmlToPromotionalContentShortcodes = (html: string) => {
	const doc = new DOMParser().parseFromString(html, 'text/html')
	const promotionalContentList = doc.querySelectorAll('.promotional-content')

	promotionalContentList.forEach((promotionalContentItem) => {
		const videoInsidePromotionalContent = promotionalContentItem.querySelector('.fr-video')
		const promotionalContentItemId = promotionalContentItem.getAttribute('data-promotional-id');
		if (promotionalContentItem.parentElement) {
			if(videoInsidePromotionalContent) {
				promotionalContentItem.parentElement.outerHTML = `<p>${videoInsidePromotionalContent.outerHTML}</p><p>{{promotionalContent:${promotionalContentItemId}}}</p>`
			} else {
				promotionalContentItem.parentElement.innerHTML = `{{promotionalContent:${promotionalContentItemId}}}`
			}
		}
	})
	return doc.body.innerHTML;
}

export const promotionalContentShortcodesToHtml = (html: string, promotionalContent: PromotionalContentSummary[]) => {
	const doc = new DOMParser().parseFromString(html, 'text/html');
	const paragraphs = doc.querySelectorAll('p');

	paragraphs.forEach(paragraph => {
		const paragraphText = paragraph.innerText;
		if (paragraphText.startsWith(startsWithString)) {
			const promotionalContentId = paragraphText.split(':')[1].split('}')[0];
			const currentPromotionalContent = promotionalContent.find(promotionContent => promotionContent._id === promotionalContentId)
			const isExpire = currentPromotionalContent?.expiryDate ? new Date(currentPromotionalContent.expiryDate).getTime() < Date.now() : false;

			if (!currentPromotionalContent || isExpire) {
				paragraph.remove()
				return;
			}

			paragraph.innerHTML = createPromotionalContent(currentPromotionalContent);
		}
	})

	return doc.body.innerHTML;
}

export const createPromotionalContent = ({name, _id, articleImage, link }: PromotionalContentSummary) => {
	return `
				<a ${link.length > 0 && 'target="_blank"'} data-promotional-name="${name}" data-promotional-id="${_id}" class="promotional-content" href="${link.length > 0 ? link: `${baseUrls.promotion.replace(':_id', _id)}`}">
						<img class="promotional-content-image" src="${articleImage}" alt="${name}" >
				</a>
			`
}

export const getPromotionalContentIdsFromHtml = (html: string) => {
	const doc = new DOMParser().parseFromString(html, 'text/html');
	const paragraphs = doc.querySelectorAll('p');
	const ids = new Set();

	paragraphs.forEach(paragraph => {
		const paragraphText = paragraph.innerText;
		if (paragraphText.startsWith(startsWithString)) {
			const promotionalContentId = paragraphText.split(':')[1].split('}')[0];
			if (promotionalContentId.length) ids.add(promotionalContentId);
		}
	});

	return [...ids];
}

export const matchTagName = (markup: string): string | null => {
	const pattern = /<([^\s>]+)(\s|>)+/
	const tagName = markup.match(pattern)
	if (tagName) return tagName[1]
	return null;
}
